const config = {
    // Environment
    NODE_ENV: 'production',
    // Internal services
    customerAPIURL: `https://customer-api.amazingco.me`,
    stripeAusPublicKey : 'pk_live_KVUIZIYZ8th2Srp06hvqhsue',
    stripeUsPublicKey : 'pk_live_l50PMpdSMdBtmrlR1EkL2DrF',
    hqURL: 'https://hq.amazingco.me',
    singularityUrl: 'https://amazingco.me',
    muiProLicenseKey: 'd2c77b638528584872d99ddec6dff998Tz00Nzg5NSxFPTE2OTAzNTU0NzMzMTEsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
    productSearchAPIURL: 'https://product-search-api.amazingco.me',
    experienceApiUrl:'https://experience-api.amazingco.me',
    eeeUrl: 'https://eee.amazingco.me',
    productUIURL: 'https://product-ui.amazingco.me',
    GTMContainerId: 'GTM-K46WJTQ', 
};

export default config;